/**
 * Prevents Stiletto marketing popups from competing with Shopify's consent UI.
 * The popup may still run its own timer, but remains inaccessible and invisible
 * until the visitor accepts, rejects or saves their cookie preferences.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var initialConsentCheckComplete = false;

  // Block the marketing timer immediately. Shopify injects its consent UI
  // asynchronously, so waiting until the banner already exists creates a race
  // where the marketing popup can win the first paint.
  root.classList.add('shopify-consent-check-pending');
  var consentSelectors = [
    '#shopify-pc__banner',
    '#shopify-pc__prefs',
    '#shopify-pc__preferences'
  ];
  var observedConsentElements = new WeakSet();
  var consentStateObserver = null;

  function isVisible(element) {
    if (!element) return false;

    var style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getBoundingClientRect().width > 0 &&
      element.getBoundingClientRect().height > 0
    );
  }

  function syncConsentState() {
    var consentIsVisible = consentSelectors.some(function (selector) {
      return isVisible(document.querySelector(selector));
    });

    root.classList.toggle('shopify-consent-is-visible', consentIsVisible);

    if (consentIsVisible || initialConsentCheckComplete) {
      root.classList.remove('shopify-consent-check-pending');
    }
  }

  function observeConsentElements() {
    consentSelectors.forEach(function (selector) {
      var element = document.querySelector(selector);
      if (!element || observedConsentElements.has(element)) return;

      observedConsentElements.add(element);
      consentStateObserver.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'open']
      });
    });
  }

  function start() {
    consentStateObserver = new MutationObserver(syncConsentState);
    observeConsentElements();
    syncConsentState();

    // Consent markup can be injected after the theme becomes interactive.
    // Observe only DOM insertions globally; attribute watching is scoped to
    // the consent elements above to avoid work during unrelated animations.
    var discoveryObserver = new MutationObserver(function () {
      observeConsentElements();
      syncConsentState();
    });
    discoveryObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Returning visitors have no consent banner. Give Shopify enough time to
    // decide/inject it, then release the marketing popup when none appears.
    window.setTimeout(function () {
      initialConsentCheckComplete = true;
      syncConsentState();
    }, 8000);

    // Shopify's banner buttons change the dialog state asynchronously.
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[id^="shopify-pc__"]')) return;
      window.setTimeout(syncConsentState, 0);
      window.setTimeout(syncConsentState, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
